export default __webpack_public_path__ + "static/media/grocery6.5c18a41f.jpeg";